import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';
import { ButtonRadiuses, ButtonSizes, ButtonTypes, CUSTOM_ICON_TYPE } from '@shared/models';
import { IconModule } from '@spartacus/storefront';
import { SdvorSpinnerComponent } from '../spinner';

@Component({
  selector: 'button[sdButton], a[sdButton]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [NgIf, NgTemplateOutlet, SdvorSpinnerComponent, IconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorButtonComponent {
  /**
   * Радиус скругления углов
   */
  @Input() radius: ButtonRadiuses = ButtonRadiuses.M;
  /**
   * Тип кнопки
   */
  @Input() type: ButtonTypes = ButtonTypes.Accent;
  /**
   * Размер кнопки
   */
  @Input() size: ButtonSizes = ButtonSizes.L;
  /**
   * Растянуть кнопку по ширине контейнера
   */
  @Input() fullWidth: boolean;
  /**
   * В состоянии загрузки
   */
  @Input() loading: boolean;
  /**
   * Если передать идентификатор иконки, то будет
   * добавлена иконка слева от контента.
   * Для большей гибкости можно добавлять иконку
   * непосредственно в самом контенте.
   */
  @Input() icon: CUSTOM_ICON_TYPE;

  @HostBinding('class')
  get classNames(): string[] {
    return [
      'button',
      this.type && this.type !== ButtonTypes.Unset && `button-type-${this.type}`,
      this.size && this.size !== ButtonSizes.Unset && `button-size-${this.size}`,
      this.radius && this.radius !== ButtonRadiuses.Unset && `button-radius-${this.radius}`,
      this.loading && `state-loading`,
      this.fullWidth && 'full-width',
    ].filter(Boolean);
  }

  // Необходим для сторибука
  constructor(protected changeDetectorRef: ChangeDetectorRef) {}
}
